<template>
  <div class="DivWithMoreArrow" :class="{ isActivated }">
    <slot />
    <span v-html="arrowRightSvg" class="icon" />
  </div>
</template>

<script setup>
import arrowRightSvg from '~/assets/site-nav/arrow-right.svg?raw'
const { isActivated } = defineProps({
  isActivated: {
    type: Boolean,
    default: false,
  },
})
</script>

<style scoped>
.DivWithMoreArrow {
  display: flex;
  align-items: center;
}
.DivWithMoreArrow .icon {
  display: block;
  color: var(--arrow-color, #ACACAC);
  margin-left: auto;
  position: relative;
  left: 0;
  transition: all 0.15s;
}
.DivWithMoreArrow.isActivated .icon,
.DivWithMoreArrow:hover .icon {
  left: 5px;
}
</style>
